import { nanoid } from "nanoid";
export const PLAYER_ID_SUFFIX_LENGTH = 6;
export const TYPED_ID_SUFFIX_LENGTH = 8;
export function generateTypedId(prefix, playerId) {
    return `${prefix}~${playerId}${nanoid(TYPED_ID_SUFFIX_LENGTH)}`;
}
export function getPlayerIdFromTypedId(typedId) {
    return getIdSuffix(typedId).slice(0, 2 + PLAYER_ID_SUFFIX_LENGTH);
}
export function getIdSuffix(id) {
    const result = id.substring(id.indexOf('~') + 1);
    return result;
}
export function getIdControlString(id) {
    return id.split('~')[0];
}
export function generatePlayerId() {
    return 'p~' + nanoid(PLAYER_ID_SUFFIX_LENGTH);
}
//# sourceMappingURL=IdUtils.js.map